<script lang="ts" setup>
import Breadcrumb from 'components/breadcrumb/index.vue'
import { useSlots } from 'vue'
withDefaults(defineProps<{
  breadcrumbAppend?: string
  hiddenBreadcrumb?: boolean
}>(), {
  breadcrumbAppend: '',
  hiddenBreadcrumb: false,
})
const slotLeft = !!useSlots().left
</script>

<template>
  <breadcrumb v-if="!hiddenBreadcrumb" :breadcrumb-append="breadcrumbAppend" />
  <div class="content-layout-container" v-bind="$attrs">
    <div v-if="slotLeft" class="left">
      <slot name="left" />
    </div>
    <!-- <div class="center" /> -->
    <div class="right">
      <slot />
    </div>
  </div>
</template>

<style lang="scss">
.content-layout-container {
  --gap: 10px;
  display: flex;
  flex-direction: row;
  gap: var(--gap);
  height: calc(100vh - 110px);
  color: #333;

  .left {
    width: 14.5%;
    min-width: 335px;
  }

  .right {
    display: flex;
    flex: 1;
    flex-direction: column;
    min-width: calc(100% - 335px - var(--gap));
    height: 100%;
    padding: 12px 20px 20px;
    overflow-y: auto;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 1px 3px 0 #e2e9fa;
  }
}
</style>
